import {BaseClickManager} from '../../../application/clickManagers/BaseClickManager';

class ExternalProductClickManager extends BaseClickManager
{
    static get entitySelector() {
        return '[data-list="external-product"]';
    }

    static get clickButtonSelector() {
        return '[data-external-product="click"]';
    }

    static get storageClickedKey() {
        return 'clickedExternalProducts';
    }

    static get urlParamName() {
        return 'epid';
    }
}

export {ExternalProductClickManager}
